
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hVfHM", function(module, exports) {
module.exports = {
    "4r5e": 1,
    "5h1t": 1,
    "5hit": 1,
    "a55": 1,
    "anal": 1,
    "anus": 1,
    "ar5e": 1,
    "arrse": 1,
    "arse": 1,
    "ass": 1,
    "ass-fucker": 1,
    "asses": 1,
    "assfucker": 1,
    "assfukka": 1,
    "asshole": 1,
    "assholes": 1,
    "asswhole": 1,
    "a_s_s": 1,
    "b!tch": 1,
    "b00bs": 1,
    "b17ch": 1,
    "b1tch": 1,
    "ballbag": 1,
    "balls": 1,
    "ballsack": 1,
    "bastard": 1,
    "beastial": 1,
    "beastiality": 1,
    "bellend": 1,
    "bestial": 1,
    "bestiality": 1,
    "bi+ch": 1,
    "biatch": 1,
    "bitch": 1,
    "bitcher": 1,
    "bitchers": 1,
    "bitches": 1,
    "bitchin": 1,
    "bitching": 1,
    "bloody": 1,
    "blow job": 1,
    "blowjob": 1,
    "blowjobs": 1,
    "boiolas": 1,
    "bollock": 1,
    "bollok": 1,
    "boner": 1,
    "boob": 1,
    "boobs": 1,
    "booobs": 1,
    "boooobs": 1,
    "booooobs": 1,
    "booooooobs": 1,
    "breasts": 1,
    "buceta": 1,
    "bugger": 1,
    "bum": 1,
    "bunny fucker": 1,
    "butt": 1,
    "butthole": 1,
    "buttmuch": 1,
    "buttplug": 1,
    "c0ck": 1,
    "c0cksucker": 1,
    "carpet muncher": 1,
    "cawk": 1,
    "chink": 1,
    "cipa": 1,
    "cl1t": 1,
    "clit": 1,
    "clitoris": 1,
    "clits": 1,
    "cnut": 1,
    "cock": 1,
    "cock-sucker": 1,
    "cockface": 1,
    "cockhead": 1,
    "cockmunch": 1,
    "cockmuncher": 1,
    "cocks": 1,
    "cocksuck": 1,
    "cocksucked": 1,
    "cocksucker": 1,
    "cocksucking": 1,
    "cocksucks": 1,
    "cocksuka": 1,
    "cocksukka": 1,
    "cok": 1,
    "cokmuncher": 1,
    "coksucka": 1,
    "coon": 1,
    "cox": 1,
    "crap": 1,
    "cum": 1,
    "cummer": 1,
    "cumming": 1,
    "cums": 1,
    "cumshot": 1,
    "cunilingus": 1,
    "cunillingus": 1,
    "cunnilingus": 1,
    "cunt": 1,
    "cuntlick": 1,
    "cuntlicker": 1,
    "cuntlicking": 1,
    "cunts": 1,
    "cyalis": 1,
    "cyberfuc": 1,
    "cyberfuck": 1,
    "cyberfucked": 1,
    "cyberfucker": 1,
    "cyberfuckers": 1,
    "cyberfucking": 1,
    "d1ck": 1,
    "damn": 1,
    "dick": 1,
    "dickhead": 1,
    "dildo": 1,
    "dildos": 1,
    "dink": 1,
    "dinks": 1,
    "dirsa": 1,
    "dlck": 1,
    "dog-fucker": 1,
    "doggin": 1,
    "dogging": 1,
    "donkeyribber": 1,
    "doosh": 1,
    "duche": 1,
    "dyke": 1,
    "ejaculate": 1,
    "ejaculated": 1,
    "ejaculates": 1,
    "ejaculating": 1,
    "ejaculatings": 1,
    "ejaculation": 1,
    "ejakulate": 1,
    "f u c k": 1,
    "f u c k e r": 1,
    "f4nny": 1,
    "fag": 1,
    "fagging": 1,
    "faggitt": 1,
    "faggot": 1,
    "faggs": 1,
    "fagot": 1,
    "fagots": 1,
    "fags": 1,
    "fanny": 1,
    "fannyflaps": 1,
    "fannyfucker": 1,
    "fanyy": 1,
    "fatass": 1,
    "fcuk": 1,
    "fcuker": 1,
    "fcuking": 1,
    "feck": 1,
    "fecker": 1,
    "felching": 1,
    "fellate": 1,
    "fellatio": 1,
    "fingerfuck": 1,
    "fingerfucked": 1,
    "fingerfucker": 1,
    "fingerfuckers": 1,
    "fingerfucking": 1,
    "fingerfucks": 1,
    "fistfuck": 1,
    "fistfucked": 1,
    "fistfucker": 1,
    "fistfuckers": 1,
    "fistfucking": 1,
    "fistfuckings": 1,
    "fistfucks": 1,
    "flange": 1,
    "fook": 1,
    "fooker": 1,
    "fuck": 1,
    "fucka": 1,
    "fucked": 1,
    "fucker": 1,
    "fuckers": 1,
    "fuckhead": 1,
    "fuckheads": 1,
    "fuckin": 1,
    "fucking": 1,
    "fuckings": 1,
    "fuckingshitmotherfucker": 1,
    "fuckme": 1,
    "fucks": 1,
    "fuckwhit": 1,
    "fuckwit": 1,
    "fudge packer": 1,
    "fudgepacker": 1,
    "fuk": 1,
    "fuker": 1,
    "fukker": 1,
    "fukkin": 1,
    "fuks": 1,
    "fukwhit": 1,
    "fukwit": 1,
    "fux": 1,
    "fux0r": 1,
    "f_u_c_k": 1,
    "gangbang": 1,
    "gangbanged": 1,
    "gangbangs": 1,
    "gaylord": 1,
    "gaysex": 1,
    "goatse": 1,
    "God": 1,
    "god-dam": 1,
    "god-damned": 1,
    "goddamn": 1,
    "goddamned": 1,
    "hardcoresex": 1,
    "hell": 1,
    "heshe": 1,
    "hoar": 1,
    "hoare": 1,
    "hoer": 1,
    "homo": 1,
    "hore": 1,
    "horniest": 1,
    "horny": 1,
    "hotsex": 1,
    "jack-off": 1,
    "jackoff": 1,
    "jap": 1,
    "jerk-off": 1,
    "jism": 1,
    "jiz": 1,
    "jizm": 1,
    "jizz": 1,
    "kawk": 1,
    "knob": 1,
    "knobead": 1,
    "knobed": 1,
    "knobend": 1,
    "knobhead": 1,
    "knobjocky": 1,
    "knobjokey": 1,
    "kock": 1,
    "kondum": 1,
    "kondums": 1,
    "kum": 1,
    "kummer": 1,
    "kumming": 1,
    "kums": 1,
    "kunilingus": 1,
    "l3i+ch": 1,
    "l3itch": 1,
    "labia": 1,
    "lust": 1,
    "lusting": 1,
    "m0f0": 1,
    "m0fo": 1,
    "m45terbate": 1,
    "ma5terb8": 1,
    "ma5terbate": 1,
    "masochist": 1,
    "master-bate": 1,
    "masterb8": 1,
    "masterbat*": 1,
    "masterbat3": 1,
    "masterbate": 1,
    "masterbation": 1,
    "masterbations": 1,
    "masturbate": 1,
    "mo-fo": 1,
    "mof0": 1,
    "mofo": 1,
    "mothafuck": 1,
    "mothafucka": 1,
    "mothafuckas": 1,
    "mothafuckaz": 1,
    "mothafucked": 1,
    "mothafucker": 1,
    "mothafuckers": 1,
    "mothafuckin": 1,
    "mothafucking": 1,
    "mothafuckings": 1,
    "mothafucks": 1,
    "mother fucker": 1,
    "motherfuck": 1,
    "motherfucked": 1,
    "motherfucker": 1,
    "motherfuckers": 1,
    "motherfuckin": 1,
    "motherfucking": 1,
    "motherfuckings": 1,
    "motherfuckka": 1,
    "motherfucks": 1,
    "muff": 1,
    "mutha": 1,
    "muthafecker": 1,
    "muthafuckker": 1,
    "muther": 1,
    "mutherfucker": 1,
    "n1gga": 1,
    "n1gger": 1,
    "nazi": 1,
    "nigg3r": 1,
    "nigg4h": 1,
    "nigga": 1,
    "niggah": 1,
    "niggas": 1,
    "niggaz": 1,
    "nigger": 1,
    "niggers": 1,
    "nob": 1,
    "nob jokey": 1,
    "nobhead": 1,
    "nobjocky": 1,
    "nobjokey": 1,
    "numbnuts": 1,
    "nutsack": 1,
    "orgasim": 1,
    "orgasims": 1,
    "orgasm": 1,
    "orgasms": 1,
    "p0rn": 1,
    "pawn": 1,
    "pecker": 1,
    "penis": 1,
    "penisfucker": 1,
    "phonesex": 1,
    "phuck": 1,
    "phuk": 1,
    "phuked": 1,
    "phuking": 1,
    "phukked": 1,
    "phukking": 1,
    "phuks": 1,
    "phuq": 1,
    "pigfucker": 1,
    "pimpis": 1,
    "piss": 1,
    "pissed": 1,
    "pisser": 1,
    "pissers": 1,
    "pisses": 1,
    "pissflaps": 1,
    "pissin": 1,
    "pissing": 1,
    "pissoff": 1,
    "poop": 1,
    "porn": 1,
    "porno": 1,
    "pornography": 1,
    "pornos": 1,
    "prick": 1,
    "pricks": 1,
    "pron": 1,
    "pube": 1,
    "pusse": 1,
    "pussi": 1,
    "pussies": 1,
    "pussy": 1,
    "pussys": 1,
    "rectum": 1,
    "retard": 1,
    "rimjaw": 1,
    "rimming": 1,
    "s hit": 1,
    "s.o.b.": 1,
    "sadist": 1,
    "schlong": 1,
    "screwing": 1,
    "scroat": 1,
    "scrote": 1,
    "scrotum": 1,
    "semen": 1,
    "sex": 1,
    "sh!+": 1,
    "sh!t": 1,
    "sh1t": 1,
    "shag": 1,
    "shagger": 1,
    "shaggin": 1,
    "shagging": 1,
    "shemale": 1,
    "shi+": 1,
    "shit": 1,
    "shitdick": 1,
    "shite": 1,
    "shited": 1,
    "shitey": 1,
    "shitfuck": 1,
    "shitfull": 1,
    "shithead": 1,
    "shiting": 1,
    "shitings": 1,
    "shits": 1,
    "shitted": 1,
    "shitter": 1,
    "shitters": 1,
    "shitting": 1,
    "shittings": 1,
    "shitty": 1,
    "skank": 1,
    "slut": 1,
    "sluts": 1,
    "smegma": 1,
    "smut": 1,
    "snatch": 1,
    "son-of-a-bitch": 1,
    "spac": 1,
    "spunk": 1,
    "s_h_i_t": 1,
    "t1tt1e5": 1,
    "t1tties": 1,
    "teets": 1,
    "teez": 1,
    "testical": 1,
    "testicle": 1,
    "tit": 1,
    "titfuck": 1,
    "tits": 1,
    "titt": 1,
    "tittie5": 1,
    "tittiefucker": 1,
    "titties": 1,
    "tittyfuck": 1,
    "tittywank": 1,
    "titwank": 1,
    "tosser": 1,
    "turd": 1,
    "tw4t": 1,
    "twat": 1,
    "twathead": 1,
    "twatty": 1,
    "twunt": 1,
    "twunter": 1,
    "v14gra": 1,
    "v1gra": 1,
    "vagina": 1,
    "viagra": 1,
    "vulva": 1,
    "w00se": 1,
    "wang": 1,
    "wank": 1,
    "wanker": 1,
    "wanky": 1,
    "whoar": 1,
    "whore": 1,
    "willies": 1,
    "willy": 1,
    "xrated": 1,
    "xxx": 1
};

});

parcelRegister("4NgFl", function(module, exports) {
module.exports = [
    "4r5e",
    "5h1t",
    "5hit",
    "a55",
    "anal",
    "anus",
    "ar5e",
    "arrse",
    "arse",
    "ass",
    "ass-fucker",
    "asses",
    "assfucker",
    "assfukka",
    "asshole",
    "assholes",
    "asswhole",
    "a_s_s",
    "b!tch",
    "b00bs",
    "b17ch",
    "b1tch",
    "ballbag",
    "balls",
    "ballsack",
    "bastard",
    "beastial",
    "beastiality",
    "bellend",
    "bestial",
    "bestiality",
    "bi+ch",
    "biatch",
    "bitch",
    "bitcher",
    "bitchers",
    "bitches",
    "bitchin",
    "bitching",
    "bloody",
    "blow job",
    "blowjob",
    "blowjobs",
    "boiolas",
    "bollock",
    "bollok",
    "boner",
    "boob",
    "boobs",
    "booobs",
    "boooobs",
    "booooobs",
    "booooooobs",
    "breasts",
    "buceta",
    "bugger",
    "bum",
    "bunny fucker",
    "butt",
    "butthole",
    "buttmuch",
    "buttplug",
    "c0ck",
    "c0cksucker",
    "carpet muncher",
    "cawk",
    "chink",
    "cipa",
    "cl1t",
    "clit",
    "clitoris",
    "clits",
    "cnut",
    "cock",
    "cock-sucker",
    "cockface",
    "cockhead",
    "cockmunch",
    "cockmuncher",
    "cocks",
    "cocksuck",
    "cocksucked",
    "cocksucker",
    "cocksucking",
    "cocksucks",
    "cocksuka",
    "cocksukka",
    "cok",
    "cokmuncher",
    "coksucka",
    "coon",
    "cox",
    "crap",
    "cum",
    "cummer",
    "cumming",
    "cums",
    "cumshot",
    "cunilingus",
    "cunillingus",
    "cunnilingus",
    "cunt",
    "cuntlick",
    "cuntlicker",
    "cuntlicking",
    "cunts",
    "cyalis",
    "cyberfuc",
    "cyberfuck",
    "cyberfucked",
    "cyberfucker",
    "cyberfuckers",
    "cyberfucking",
    "d1ck",
    "damn",
    "dick",
    "dickhead",
    "dildo",
    "dildos",
    "dink",
    "dinks",
    "dirsa",
    "dlck",
    "dog-fucker",
    "doggin",
    "dogging",
    "donkeyribber",
    "doosh",
    "duche",
    "dyke",
    "ejaculate",
    "ejaculated",
    "ejaculates",
    "ejaculating",
    "ejaculatings",
    "ejaculation",
    "ejakulate",
    "f u c k",
    "f u c k e r",
    "f4nny",
    "fag",
    "fagging",
    "faggitt",
    "faggot",
    "faggs",
    "fagot",
    "fagots",
    "fags",
    "fanny",
    "fannyflaps",
    "fannyfucker",
    "fanyy",
    "fatass",
    "fcuk",
    "fcuker",
    "fcuking",
    "feck",
    "fecker",
    "felching",
    "fellate",
    "fellatio",
    "fingerfuck",
    "fingerfucked",
    "fingerfucker",
    "fingerfuckers",
    "fingerfucking",
    "fingerfucks",
    "fistfuck",
    "fistfucked",
    "fistfucker",
    "fistfuckers",
    "fistfucking",
    "fistfuckings",
    "fistfucks",
    "flange",
    "fook",
    "fooker",
    "fuck",
    "fucka",
    "fucked",
    "fucker",
    "fuckers",
    "fuckhead",
    "fuckheads",
    "fuckin",
    "fucking",
    "fuckings",
    "fuckingshitmotherfucker",
    "fuckme",
    "fucks",
    "fuckwhit",
    "fuckwit",
    "fudge packer",
    "fudgepacker",
    "fuk",
    "fuker",
    "fukker",
    "fukkin",
    "fuks",
    "fukwhit",
    "fukwit",
    "fux",
    "fux0r",
    "f_u_c_k",
    "gangbang",
    "gangbanged",
    "gangbangs",
    "gaylord",
    "gaysex",
    "goatse",
    "God",
    "god-dam",
    "god-damned",
    "goddamn",
    "goddamned",
    "hardcoresex",
    "hell",
    "heshe",
    "hoar",
    "hoare",
    "hoer",
    "homo",
    "hore",
    "horniest",
    "horny",
    "hotsex",
    "jack-off",
    "jackoff",
    "jap",
    "jerk-off",
    "jism",
    "jiz",
    "jizm",
    "jizz",
    "kawk",
    "knob",
    "knobead",
    "knobed",
    "knobend",
    "knobhead",
    "knobjocky",
    "knobjokey",
    "kock",
    "kondum",
    "kondums",
    "kum",
    "kummer",
    "kumming",
    "kums",
    "kunilingus",
    "l3i+ch",
    "l3itch",
    "labia",
    "lust",
    "lusting",
    "m0f0",
    "m0fo",
    "m45terbate",
    "ma5terb8",
    "ma5terbate",
    "masochist",
    "master-bate",
    "masterb8",
    "masterbat*",
    "masterbat3",
    "masterbate",
    "masterbation",
    "masterbations",
    "masturbate",
    "mo-fo",
    "mof0",
    "mofo",
    "mothafuck",
    "mothafucka",
    "mothafuckas",
    "mothafuckaz",
    "mothafucked",
    "mothafucker",
    "mothafuckers",
    "mothafuckin",
    "mothafucking",
    "mothafuckings",
    "mothafucks",
    "mother fucker",
    "motherfuck",
    "motherfucked",
    "motherfucker",
    "motherfuckers",
    "motherfuckin",
    "motherfucking",
    "motherfuckings",
    "motherfuckka",
    "motherfucks",
    "muff",
    "mutha",
    "muthafecker",
    "muthafuckker",
    "muther",
    "mutherfucker",
    "n1gga",
    "n1gger",
    "nazi",
    "nigg3r",
    "nigg4h",
    "nigga",
    "niggah",
    "niggas",
    "niggaz",
    "nigger",
    "niggers",
    "nob",
    "nob jokey",
    "nobhead",
    "nobjocky",
    "nobjokey",
    "numbnuts",
    "nutsack",
    "orgasim",
    "orgasims",
    "orgasm",
    "orgasms",
    "p0rn",
    "pawn",
    "pecker",
    "penis",
    "penisfucker",
    "phonesex",
    "phuck",
    "phuk",
    "phuked",
    "phuking",
    "phukked",
    "phukking",
    "phuks",
    "phuq",
    "pigfucker",
    "pimpis",
    "piss",
    "pissed",
    "pisser",
    "pissers",
    "pisses",
    "pissflaps",
    "pissin",
    "pissing",
    "pissoff",
    "poop",
    "porn",
    "porno",
    "pornography",
    "pornos",
    "prick",
    "pricks",
    "pron",
    "pube",
    "pusse",
    "pussi",
    "pussies",
    "pussy",
    "pussys",
    "rectum",
    "retard",
    "rimjaw",
    "rimming",
    "s hit",
    "s.o.b.",
    "sadist",
    "schlong",
    "screwing",
    "scroat",
    "scrote",
    "scrotum",
    "semen",
    "sex",
    "sh!+",
    "sh!t",
    "sh1t",
    "shag",
    "shagger",
    "shaggin",
    "shagging",
    "shemale",
    "shi+",
    "shit",
    "shitdick",
    "shite",
    "shited",
    "shitey",
    "shitfuck",
    "shitfull",
    "shithead",
    "shiting",
    "shitings",
    "shits",
    "shitted",
    "shitter",
    "shitters",
    "shitting",
    "shittings",
    "shitty",
    "skank",
    "slut",
    "sluts",
    "smegma",
    "smut",
    "snatch",
    "son-of-a-bitch",
    "spac",
    "spunk",
    "s_h_i_t",
    "t1tt1e5",
    "t1tties",
    "teets",
    "teez",
    "testical",
    "testicle",
    "tit",
    "titfuck",
    "tits",
    "titt",
    "tittie5",
    "tittiefucker",
    "titties",
    "tittyfuck",
    "tittywank",
    "titwank",
    "tosser",
    "turd",
    "tw4t",
    "twat",
    "twathead",
    "twatty",
    "twunt",
    "twunter",
    "v14gra",
    "v1gra",
    "vagina",
    "viagra",
    "vulva",
    "w00se",
    "wang",
    "wank",
    "wanker",
    "wanky",
    "whoar",
    "whore",
    "willies",
    "willy",
    "xrated",
    "xxx"
];

});

parcelRegister("76U8F", function(module, exports) {
module.exports = /\b(4r5e|5h1t|5hit|a55|anal|anus|ar5e|arrse|arse|ass|ass-fucker|asses|assfucker|assfukka|asshole|assholes|asswhole|a_s_s|b!tch|b00bs|b17ch|b1tch|ballbag|balls|ballsack|bastard|beastial|beastiality|bellend|bestial|bestiality|bi\+ch|biatch|bitch|bitcher|bitchers|bitches|bitchin|bitching|bloody|blow job|blowjob|blowjobs|boiolas|bollock|bollok|boner|boob|boobs|booobs|boooobs|booooobs|booooooobs|breasts|buceta|bugger|bum|bunny fucker|butt|butthole|buttmuch|buttplug|c0ck|c0cksucker|carpet muncher|cawk|chink|cipa|cl1t|clit|clitoris|clits|cnut|cock|cock-sucker|cockface|cockhead|cockmunch|cockmuncher|cocks|cocksuck|cocksucked|cocksucker|cocksucking|cocksucks|cocksuka|cocksukka|cok|cokmuncher|coksucka|coon|cox|crap|cum|cummer|cumming|cums|cumshot|cunilingus|cunillingus|cunnilingus|cunt|cuntlick|cuntlicker|cuntlicking|cunts|cyalis|cyberfuc|cyberfuck|cyberfucked|cyberfucker|cyberfuckers|cyberfucking|d1ck|damn|dick|dickhead|dildo|dildos|dink|dinks|dirsa|dlck|dog-fucker|doggin|dogging|donkeyribber|doosh|duche|dyke|ejaculate|ejaculated|ejaculates|ejaculating|ejaculatings|ejaculation|ejakulate|f u c k|f u c k e r|f4nny|fag|fagging|faggitt|faggot|faggs|fagot|fagots|fags|fanny|fannyflaps|fannyfucker|fanyy|fatass|fcuk|fcuker|fcuking|feck|fecker|felching|fellate|fellatio|fingerfuck|fingerfucked|fingerfucker|fingerfuckers|fingerfucking|fingerfucks|fistfuck|fistfucked|fistfucker|fistfuckers|fistfucking|fistfuckings|fistfucks|flange|fook|fooker|fuck|fucka|fucked|fucker|fuckers|fuckhead|fuckheads|fuckin|fucking|fuckings|fuckingshitmotherfucker|fuckme|fucks|fuckwhit|fuckwit|fudge packer|fudgepacker|fuk|fuker|fukker|fukkin|fuks|fukwhit|fukwit|fux|fux0r|f_u_c_k|gangbang|gangbanged|gangbangs|gaylord|gaysex|goatse|God|god-dam|god-damned|goddamn|goddamned|hardcoresex|hell|heshe|hoar|hoare|hoer|homo|hore|horniest|horny|hotsex|jack-off|jackoff|jap|jerk-off|jism|jiz|jizm|jizz|kawk|knob|knobead|knobed|knobend|knobhead|knobjocky|knobjokey|kock|kondum|kondums|kum|kummer|kumming|kums|kunilingus|l3i\+ch|l3itch|labia|lust|lusting|m0f0|m0fo|m45terbate|ma5terb8|ma5terbate|masochist|master-bate|masterb8|masterbat*|masterbat3|masterbate|masterbation|masterbations|masturbate|mo-fo|mof0|mofo|mothafuck|mothafucka|mothafuckas|mothafuckaz|mothafucked|mothafucker|mothafuckers|mothafuckin|mothafucking|mothafuckings|mothafucks|mother fucker|motherfuck|motherfucked|motherfucker|motherfuckers|motherfuckin|motherfucking|motherfuckings|motherfuckka|motherfucks|muff|mutha|muthafecker|muthafuckker|muther|mutherfucker|n1gga|n1gger|nazi|nigg3r|nigg4h|nigga|niggah|niggas|niggaz|nigger|niggers|nob|nob jokey|nobhead|nobjocky|nobjokey|numbnuts|nutsack|orgasim|orgasims|orgasm|orgasms|p0rn|pawn|pecker|penis|penisfucker|phonesex|phuck|phuk|phuked|phuking|phukked|phukking|phuks|phuq|pigfucker|pimpis|piss|pissed|pisser|pissers|pisses|pissflaps|pissin|pissing|pissoff|poop|porn|porno|pornography|pornos|prick|pricks|pron|pube|pusse|pussi|pussies|pussy|pussys|rectum|retard|rimjaw|rimming|s hit|s.o.b.|sadist|schlong|screwing|scroat|scrote|scrotum|semen|sex|sh!\+|sh!t|sh1t|shag|shagger|shaggin|shagging|shemale|shi\+|shit|shitdick|shite|shited|shitey|shitfuck|shitfull|shithead|shiting|shitings|shits|shitted|shitter|shitters|shitting|shittings|shitty|skank|slut|sluts|smegma|smut|snatch|son-of-a-bitch|spac|spunk|s_h_i_t|t1tt1e5|t1tties|teets|teez|testical|testicle|tit|titfuck|tits|titt|tittie5|tittiefucker|titties|tittyfuck|tittywank|titwank|tosser|turd|tw4t|twat|twathead|twatty|twunt|twunter|v14gra|v1gra|vagina|viagra|vulva|w00se|wang|wank|wanker|wanky|whoar|whore|willies|willy|xrated|xxx)\b/gi;

});

var $d397f6c459ccf808$exports = {};
var $f3c9c3cc57413c91$exports = {};
$f3c9c3cc57413c91$exports = JSON.parse('{"words":["ahole","anus","ash0le","ash0les","asholes","ass","Ass Monkey","Assface","assh0le","assh0lez","asshole","assholes","assholz","asswipe","azzhole","bassterds","bastard","bastards","bastardz","basterds","basterdz","Biatch","bitch","bitches","Blow Job","boffing","butthole","buttwipe","c0ck","c0cks","c0k","Carpet Muncher","cawk","cawks","Clit","cnts","cntz","cock","cockhead","cock-head","cocks","CockSucker","cock-sucker","crap","cum","cunt","cunts","cuntz","dick","dild0","dild0s","dildo","dildos","dilld0","dilld0s","dominatricks","dominatrics","dominatrix","dyke","enema","f u c k","f u c k e r","fag","fag1t","faget","fagg1t","faggit","faggot","fagg0t","fagit","fags","fagz","faig","faigs","fart","flipping the bird","fuck","fucker","fuckin","fucking","fucks","Fudge Packer","fuk","Fukah","Fuken","fuker","Fukin","Fukk","Fukkah","Fukken","Fukker","Fukkin","g00k","God-damned","h00r","h0ar","h0re","hells","hoar","hoor","hoore","jackoff","jap","japs","jerk-off","jisim","jiss","jizm","jizz","knob","knobs","knobz","kunt","kunts","kuntz","Lezzian","Lipshits","Lipshitz","masochist","masokist","massterbait","masstrbait","masstrbate","masterbaiter","masterbate","masterbates","Motha Fucker","Motha Fuker","Motha Fukkah","Motha Fukker","Mother Fucker","Mother Fukah","Mother Fuker","Mother Fukkah","Mother Fukker","mother-fucker","Mutha Fucker","Mutha Fukah","Mutha Fuker","Mutha Fukkah","Mutha Fukker","n1gr","nastt","nigger;","nigur;","niiger;","niigr;","orafis","orgasim;","orgasm","orgasum","oriface","orifice","orifiss","packi","packie","packy","paki","pakie","paky","pecker","peeenus","peeenusss","peenus","peinus","pen1s","penas","penis","penis-breath","penus","penuus","Phuc","Phuck","Phuk","Phuker","Phukker","polac","polack","polak","Poonani","pr1c","pr1ck","pr1k","pusse","pussee","pussy","puuke","puuker","qweir","recktum","rectum","retard","sadist","scank","schlong","screwing","semen","sex","sexy","Sh!t","sh1t","sh1ter","sh1ts","sh1tter","sh1tz","shit","shits","shitter","Shitty","Shity","shitz","Shyt","Shyte","Shytty","Shyty","skanck","skank","skankee","skankey","skanks","Skanky","slag","slut","sluts","Slutty","slutz","son-of-a-bitch","tit","turd","va1jina","vag1na","vagiina","vagina","vaj1na","vajina","vullva","vulva","w0p","wh00r","wh0re","whore","xrated","xxx","b!+ch","bitch","blowjob","clit","arschloch","fuck","shit","ass","asshole","b!tch","b17ch","b1tch","bastard","bi+ch","boiolas","buceta","c0ck","cawk","chink","cipa","clits","cock","cum","cunt","dildo","dirsa","ejakulate","fatass","fcuk","fuk","fux0r","hoer","hore","jism","kawk","l3itch","l3i+ch","masturbate","masterbat*","masterbat3","motherfucker","s.o.b.","mofo","nazi","nigga","nigger","nutsack","phuck","pimpis","pusse","pussy","scrotum","sh!t","shemale","shi+","sh!+","slut","smut","teets","tits","boobs","b00bs","teez","testical","testicle","titt","w00se","jackoff","wank","whoar","whore","*damn","*dyke","*fuck*","*shit*","@$$","amcik","andskota","arse*","assrammer","ayir","bi7ch","bitch*","bollock*","breasts","butt-pirate","cabron","cazzo","chraa","chuj","Cock*","cunt*","d4mn","daygo","dego","dick*","dike*","dupa","dziwka","ejackulate","Ekrem*","Ekto","enculer","faen","fag*","fanculo","fanny","feces","feg","Felcher","ficken","fitt*","Flikker","foreskin","Fotze","Fu(*","fuk*","futkretzn","gook","guiena","h0r","h4x0r","hell","helvete","hoer*","honkey","Huevon","hui","injun","jizz","kanker*","kike","klootzak","kraut","knulle","kuk","kuksuger","Kurac","kurwa","kusi*","kyrpa*","lesbo","mamhoon","masturbat*","merd*","mibun","monkleigh","mouliewop","muie","mulkku","muschi","nazis","nepesaurio","nigger*","orospu","paska*","perse","picka","pierdol*","pillu*","pimmel","piss*","pizda","poontsee","poop","porn","p0rn","pr0n","preteen","pula","pule","puta","puto","qahbeh","queef*","rautenberg","schaffer","scheiss*","schlampe","schmuck","screw","sh!t*","sharmuta","sharmute","shipal","shiz","skribz","skurwysyn","sphencter","spic","spierdalaj","splooge","suka","b00b*","testicle*","titt*","twat","vittu","wank*","wetback*","wichser","wop*","yed","zabourah"]}');


var $d397f6c459ccf808$require$localList = $f3c9c3cc57413c91$exports.words;
var $d9bdf8e0eeb17b82$exports = {};



$d9bdf8e0eeb17b82$exports = {
    object: (parcelRequire("hVfHM")),
    array: (parcelRequire("4NgFl")),
    regex: (parcelRequire("76U8F"))
};


var $d397f6c459ccf808$require$baseList = $d9bdf8e0eeb17b82$exports.array;
class $d397f6c459ccf808$var$Filter {
    /**
   * Filter constructor.
   * @constructor
   * @param {object} options - Filter instance options
   * @param {boolean} options.emptyList - Instantiate filter with no blacklist
   * @param {array} options.list - Instantiate filter with custom list
   * @param {string} options.placeHolder - Character used to replace profane words.
   * @param {string} options.regex - Regular expression used to sanitize words before comparing them to blacklist.
   * @param {string} options.replaceRegex - Regular expression used to replace profane words with placeHolder.
   * @param {string} options.splitRegex - Regular expression used to split a string into words.
   */ constructor(options = {}){
        Object.assign(this, {
            list: options.emptyList && [] || Array.prototype.concat.apply($d397f6c459ccf808$require$localList, [
                $d397f6c459ccf808$require$baseList,
                options.list || []
            ]),
            exclude: options.exclude || [],
            splitRegex: options.splitRegex || /\b/,
            placeHolder: options.placeHolder || "*",
            regex: options.regex || /[^a-zA-Z0-9|\$|\@]|\^/g,
            replaceRegex: options.replaceRegex || /\w/g
        });
    }
    /**
   * Determine if a string contains profane language.
   * @param {string} string - String to evaluate for profanity.
   */ isProfane(string) {
        return this.list.filter((word)=>{
            const wordExp = new RegExp(`\\b${word.replace(/(\W)/g, "\\$1")}\\b`, "gi");
            return !this.exclude.includes(word.toLowerCase()) && wordExp.test(string);
        }).length > 0 || false;
    }
    /**
   * Replace a word with placeHolder characters;
   * @param {string} string - String to replace.
   */ replaceWord(string) {
        return string.replace(this.regex, "").replace(this.replaceRegex, this.placeHolder);
    }
    /**
   * Evaluate a string for profanity and return an edited version.
   * @param {string} string - Sentence to filter.
   */ clean(string) {
        return string.split(this.splitRegex).map((word)=>{
            return this.isProfane(word) ? this.replaceWord(word) : word;
        }).join(this.splitRegex.exec(string)[0]);
    }
    /**
   * Add word(s) to blacklist filter / remove words from whitelist filter
   * @param {...string} word - Word(s) to add to blacklist
   */ addWords() {
        let words = Array.from(arguments);
        this.list.push(...words);
        words.map((word)=>word.toLowerCase()).forEach((word)=>{
            if (this.exclude.includes(word)) this.exclude.splice(this.exclude.indexOf(word), 1);
        });
    }
    /**
   * Add words to whitelist filter
   * @param {...string} word - Word(s) to add to whitelist.
   */ removeWords() {
        this.exclude.push(...Array.from(arguments).map((word)=>word.toLowerCase()));
    }
}
$d397f6c459ccf808$exports = $d397f6c459ccf808$var$Filter;


function $4c0f0ee047d80e21$export$c6141e7c4932b646(canvas) {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Could not get canvas context");
    return ctx;
}


const $3bfc08fbd98fce76$export$6435dfeef9d116d2 = [
    {
        time: 0,
        color: "#F2D5A2"
    },
    {
        time: 15,
        color: "#FBE58A"
    },
    {
        time: 30,
        color: "#87CEEB"
    },
    {
        time: 45,
        color: "#2D68C4"
    },
    {
        time: 60,
        color: "#000033"
    }
];


const $ef4c3eb9f5926687$var$green = "#526f52";
const $ef4c3eb9f5926687$var$darkGreen = "#2f422f";
function $ef4c3eb9f5926687$export$69c8eaa09502cdf7(ctx, { cursorX: cursorX, cursorY: cursorY, cursorRadius: cursorRadius, thickness: thickness, onTarget: onTarget, rotationDegrees: rotationDegrees }) {
    const circumference = 2 * Math.PI * cursorRadius;
    const dashLength = 5; // Initial desired length of dash
    const spaceLength = 16; // Initial desired length of space
    const totalDashSpaceLength = dashLength + spaceLength;
    const numberOfDashes = Math.floor(circumference / totalDashSpaceLength);
    const adjustedTotalLength = circumference / numberOfDashes;
    const adjustedDashLength = dashLength / totalDashSpaceLength * adjustedTotalLength;
    const adjustedSpaceLength = adjustedTotalLength - adjustedDashLength;
    const cursorColor = "rgba(255, 255, 255, 1)";
    // Save the current context state
    ctx.save();
    // Set the style for the cursor
    ctx.strokeStyle = cursorColor;
    ctx.lineWidth = thickness;
    ctx.setLineDash([
        adjustedDashLength,
        adjustedSpaceLength
    ]);
    // Rotate the canvas around the cursor if overlapping
    if (onTarget) {
        ctx.translate(cursorX, cursorY);
        ctx.rotate(rotationDegrees * Math.PI / 180);
        ctx.translate(-cursorX, -cursorY);
    }
    // Draw the cursor
    ctx.beginPath();
    ctx.arc(cursorX, cursorY, cursorRadius, 0, Math.PI * 2);
    ctx.stroke();
    // Restore the original context state
    ctx.restore();
    ctx.setLineDash([]);
}
function $ef4c3eb9f5926687$export$746a4a768e6973c8(ctx, { centerY: centerY, circleRadius: circleRadius, control: control, cursorX: cursorX, cursorY: cursorY, isLeftArm: isLeftArm, start: start }) {
    // Calculate the end point based on the cursor position and circleRadius
    const angleToCursor = Math.atan2(cursorY - start.y, cursorX - start.x);
    let end = {
        x: cursorX - Math.cos(angleToCursor) * (circleRadius * 2),
        y: cursorY - Math.sin(angleToCursor) * (circleRadius * 2)
    };
    // Constrain the arm to its respective side with a gap around the center
    const midX = ctx.canvas.width / 2;
    const gapRadius = circleRadius * 5.5; // Adjust the gap as needed
    if (isLeftArm) end.x = Math.min(end.x, midX - gapRadius);
    else end.x = Math.max(end.x, midX + gapRadius);
    // Restrict the y position of the arm so it does not go above the top half of the canvas
    const maxY = ctx.canvas.height / 1.5;
    end.y = Math.max(end.y, maxY);
    // Function to draw a single Bezier curve
    function drawCurve(startX, startY, control1Y, control2Y, endX, endY) {
        ctx.beginPath();
        ctx.moveTo(startX, startY);
        ctx.bezierCurveTo(startX, startY + (endY - startY) * control1Y, startX, startY + (endY - startY) * control2Y, endX, endY);
        ctx.stroke();
    }
    // Set line width to twice the radius to match the circle's diameter
    ctx.strokeStyle = $ef4c3eb9f5926687$var$green;
    ctx.fillStyle = $ef4c3eb9f5926687$var$green;
    ctx.lineWidth = circleRadius * 2;
    // Offset for the additional curves
    let offsetX = 50; // Adjust this value for wider or narrower base
    // Draw the original curve and additional offset curves
    drawCurve(start.x, centerY, 0.2, 0.4, end.x, end.y);
    drawCurve(start.x - offsetX, start.y, 0.2, 0.4, end.x, end.y);
    drawCurve(start.x + offsetX, start.y, 0.2, 0.4, end.x, end.y);
    // Draw circle at the end point
    ctx.beginPath();
    ctx.arc(end.x, end.y, circleRadius, 0, Math.PI * 2);
    ctx.fill();
}
function $ef4c3eb9f5926687$var$drawEquilateralTriangle(ctx, { x: x, y: y, circleRadius: circleRadius, size: size, angle: angle, color: color }) {
    const height = size * Math.sqrt(3) / 2;
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(angle);
    // Position the base of the triangle at the circle's edge
    ctx.beginPath();
    ctx.moveTo(0, -circleRadius - height);
    ctx.lineTo(-size / 2, -circleRadius);
    ctx.lineTo(size / 2, -circleRadius);
    ctx.closePath();
    ctx.fillStyle = color;
    ctx.fill();
    ctx.restore();
}
function $ef4c3eb9f5926687$export$1a7019e83c643e8b({ cursorY: cursorY, centerY: centerY, maxDistance: maxDistance, minDistance: minDistance, threshold: threshold, flyDistance: flyDistance }) {
    // The closer the cursor is to the fly, the more the jaw should open
    const jawOpenFactor = Math.max(0, 1 - flyDistance / threshold);
    const distanceFromBottom = Math.abs(cursorY - centerY);
    let offset;
    if (distanceFromBottom > maxDistance) offset = 0; // Jaw is not revealed
    else {
        // Interpolate the jaw position based on the cursor's distance from bottom
        offset = -100 * (1 - (distanceFromBottom - minDistance) / (maxDistance - minDistance));
        // Adjust the offset based on the proximity to the fly
        offset *= jawOpenFactor;
    }
    return Math.max(offset, -100); // Ensure offset is not less than -100
}
function $ef4c3eb9f5926687$export$cacb359be49a4863(ctx, { canvas: canvas, centerY: centerY, jawOffset: jawOffset }) {
    const centerX = canvas.width / 2;
    // const centerY = canvas.height; // The Y position of the body's bottom
    const radiusX = canvas.width / 2.25;
    const radiusY = canvas.height / 4;
    // Draw the jaw circle
    ctx.beginPath();
    ctx.ellipse(centerX, centerY + jawOffset, radiusX, radiusY, 0, 0, Math.PI * 2);
    ctx.fillStyle = $ef4c3eb9f5926687$var$darkGreen;
    ctx.fill();
}
function $ef4c3eb9f5926687$export$c4be8a24729de865(ctx, { centerX: centerX, centerY: centerY, radiusX: radiusX, radiusY: radiusY }) {
    ctx.beginPath();
    ctx.ellipse(centerX, centerY, radiusX, radiusY, 0, 0, Math.PI * 2);
    ctx.fillStyle = $ef4c3eb9f5926687$var$green;
    ctx.fill();
}
function $ef4c3eb9f5926687$export$b02dbbf73e520614(ctx, { height: height, width: width, x: x, xOffset: xOffset, yOffset: yOffset }) {
    // Drawing left ear part
    ctx.save();
    ctx.beginPath();
    ctx.ellipse(x - xOffset, yOffset, width, height, Math.PI / 12, 0, Math.PI * 2);
    ctx.fillStyle = $ef4c3eb9f5926687$var$darkGreen;
    ctx.fill();
    ctx.restore();
    // Drawing right ear part
    ctx.save();
    ctx.beginPath();
    ctx.ellipse(x + xOffset, yOffset, width, height, -Math.PI / 12, 0, Math.PI * 2);
    ctx.fillStyle = $ef4c3eb9f5926687$var$darkGreen;
    ctx.fill();
    ctx.restore();
}
function $ef4c3eb9f5926687$export$5987d8c342abca63(ctx, { x: x, width: width, height: height, xOffset: xOffset, yOffset: yOffset }) {
    // Drawing left nose part
    ctx.save();
    ctx.beginPath();
    ctx.ellipse(x - xOffset, yOffset, width, height, Math.PI / 12, 0, Math.PI * 2);
    ctx.fillStyle = $ef4c3eb9f5926687$var$darkGreen;
    ctx.fill();
    ctx.restore();
    // Drawing right nose part
    ctx.save();
    ctx.beginPath();
    ctx.ellipse(x + xOffset, yOffset, width, height, -Math.PI / 12, 0, Math.PI * 2);
    ctx.fillStyle = $ef4c3eb9f5926687$var$darkGreen;
    ctx.fill();
    ctx.restore();
}
function $ef4c3eb9f5926687$export$ae8c489e78e84ecd(ctx, { canvas: canvas, cursorX: cursorX, cursorY: cursorY, eyesY: eyesY }) {
    const eyeRadius = canvas.width / 20;
    const eyesX = canvas.width / 2;
    const eyeSeparation = canvas.width / 10;
    const leftEyeX = eyesX - eyeSeparation; // Position of the left eye
    const rightEyeX = eyesX + eyeSeparation; // Position of the right eye
    const leftEyeY = eyesY;
    const rightEyeY = eyesY;
    // Function to calculate the eyelid's vertical offset
    const calculateEyelidOffset = (distanceToEye)=>{
        const maxOpenDistance = 1000;
        const fullyClosedDistance = 50;
        if (distanceToEye >= maxOpenDistance) return eyeRadius; // Eyelid is fully open
        else if (distanceToEye <= fullyClosedDistance) return 0; // Eyelid is fully closed
        else // Interpolate eyelid position
        return eyeRadius * (distanceToEye - fullyClosedDistance) / (maxOpenDistance - fullyClosedDistance);
    };
    // Calculate distance from the cursor to each eye
    const distanceToLeftEye = $ef4c3eb9f5926687$var$calculateDistance(leftEyeX, leftEyeY, cursorX, cursorY);
    const distanceToRightEye = $ef4c3eb9f5926687$var$calculateDistance(rightEyeX, rightEyeY, cursorX, cursorY);
    // Calculate the eyelid offsets
    const leftEyelidOffset = calculateEyelidOffset(distanceToLeftEye);
    const rightEyelidOffset = calculateEyelidOffset(distanceToRightEye);
    // Draw left eye white
    ctx.beginPath();
    ctx.arc(leftEyeX, leftEyeY, eyeRadius, 0, Math.PI * 2);
    ctx.fillStyle = "white";
    ctx.fill();
    // Draw right eye white
    ctx.beginPath();
    ctx.arc(rightEyeX, rightEyeY, eyeRadius, 0, Math.PI * 2);
    ctx.fillStyle = "white";
    ctx.fill();
    $ef4c3eb9f5926687$export$d30f04e39a37a89c(ctx, {
        cursorX: cursorX,
        cursorY: cursorY,
        eyesX: eyesX,
        eyeSeparation: eyeSeparation,
        leftEyeY: leftEyeY,
        rightEyeY: rightEyeY,
        eyeRadius: eyeRadius
    });
    // Draw left eyelid
    ctx.beginPath();
    ctx.ellipse(leftEyeX, leftEyeY + eyeRadius / 2 + leftEyelidOffset, eyeRadius * 2, eyeRadius, 0, 0, Math.PI * 2, false);
    ctx.fillStyle = $ef4c3eb9f5926687$var$green;
    ctx.fill();
    // Draw right eyelid
    ctx.beginPath();
    ctx.ellipse(rightEyeX, rightEyeY + eyeRadius / 2 + rightEyelidOffset, eyeRadius * 2, eyeRadius, 0, 0, Math.PI * 2, false);
    ctx.fillStyle = $ef4c3eb9f5926687$var$green;
    ctx.fill();
}
// Helper function to calculate distance between two points
function $ef4c3eb9f5926687$var$calculateDistance(pointX, pointY, cursorX, cursorY) {
    const dx = cursorX - pointX;
    const dy = cursorY - pointY;
    return Math.sqrt(dx * dx + dy * dy);
}
function $ef4c3eb9f5926687$export$d30f04e39a37a89c(ctx, { cursorX: cursorX, cursorY: cursorY, eyesX: eyesX, eyeSeparation: eyeSeparation, leftEyeY: leftEyeY, rightEyeY: rightEyeY, eyeRadius: eyeRadius }) {
    // Positions for the left and right eyes
    const leftEyeX = eyesX - eyeSeparation;
    const rightEyeX = eyesX + eyeSeparation;
    const pupilRadius = eyeRadius / 1.25; // Radius of the pupil
    // Calculate pupil positions
    const leftPupil = $ef4c3eb9f5926687$var$calculatePupilPosition(leftEyeX, leftEyeY, eyeRadius, cursorX, cursorY, pupilRadius);
    const rightPupil = $ef4c3eb9f5926687$var$calculatePupilPosition(rightEyeX, rightEyeY, eyeRadius, cursorX, cursorY, pupilRadius);
    // Draw left pupil
    ctx.beginPath();
    ctx.ellipse(leftPupil.x, leftPupil.y, pupilRadius / 2, pupilRadius, 0, 0, Math.PI * 2);
    ctx.fillStyle = "black";
    ctx.fill();
    // Draw right pupil
    ctx.beginPath();
    ctx.ellipse(rightPupil.x, rightPupil.y, pupilRadius / 2, pupilRadius, 0, 0, Math.PI * 2);
    ctx.fillStyle = "black";
    ctx.fill();
}
function $ef4c3eb9f5926687$var$calculatePupilPosition(eyeX, eyeY, eyeRadius, cursorX, cursorY, pupilRadius) {
    const dx = cursorX - eyeX;
    const dy = cursorY - eyeY;
    const distance = Math.sqrt(dx * dx + dy * dy);
    if (distance < eyeRadius - pupilRadius) // Cursor is within the eye's range
    return {
        x: cursorX,
        y: cursorY
    };
    else {
        // Cursor is outside the eye's range, clamp the pupil's movement
        const angle = Math.atan2(dy, dx);
        return {
            x: eyeX + (eyeRadius - pupilRadius) * Math.cos(angle),
            y: eyeY + (eyeRadius - pupilRadius) * Math.sin(angle)
        };
    }
}
function $ef4c3eb9f5926687$export$dfd0e7619f9e97a5(ctx, canvas) {
    const mouthWidth = 80; // Adjust the width of the mouth as needed
    const mouthHeight = 10; // Adjust the height/curve of the mouth as needed
    const centerX = canvas.width / 2; // The mouth will be centered horizontally
    const centerY = canvas.height - canvas.height / 4 + 40; // Position the mouth below the eyes
    ctx.beginPath();
    ctx.moveTo(centerX - mouthWidth / 2, centerY); // Start from the left end of the mouth
    // Draw a quadratic curve for the mouth
    ctx.quadraticCurveTo(centerX, centerY + mouthHeight, centerX + mouthWidth / 2, centerY);
    ctx.stroke(); // Stroke the mouth
}
function $ef4c3eb9f5926687$var$lerp(start, end, amt) {
    return (1 - amt) * start + amt * end;
}
function $ef4c3eb9f5926687$export$f3bec86bc9a1c71a(ctx, { canvas: canvas, cursorX: cursorX, cursorY: cursorY, eyesY: eyesY, flyPosition: flyPosition, isMouseDown: isMouseDown, targetTonguePosition: targetTonguePosition, tonguePhysics: tonguePhysics }) {
    const mouthCenterX = canvas.width / 2;
    const mouthCenterY = eyesY - canvas.width / 30;
    const dxFly = tonguePhysics.target.x - tonguePhysics.position.x;
    const dyFly = tonguePhysics.target.y - tonguePhysics.position.y;
    if (Math.abs(tonguePhysics.position.y - mouthCenterY) < 100) tonguePhysics.retracting = false;
    if (isMouseDown) {
        // When the mouse is pressed, target the cursor's position
        tonguePhysics.target.x = targetTonguePosition.x;
        tonguePhysics.target.y = targetTonguePosition.y;
    } else {
        // When the mouse is released and the tongue isn't retracting yet, follow the cursor
        const tongueRadius = canvas.width / 15;
        const spaceRadius = tongueRadius * 2;
        const tonguePosition = $ef4c3eb9f5926687$var$calculateCirclePosition(mouthCenterX, mouthCenterY, spaceRadius, cursorX, cursorY, tongueRadius);
        if (!tonguePhysics.retracting && !isMouseDown) {
            const lerpAmount = 0.05; // Adjust this value to control the smoothing
            tonguePhysics.retracting = false;
            // Calculate distance to the fly
            const distanceToFly = $ef4c3eb9f5926687$var$calculateDistance(flyPosition.x, flyPosition.y, cursorX, cursorY);
            const maxExtendDistance = canvas.width / 30; // Maximum distance for the tongue to extend
            const tongueExtendFactor = Math.max(0, 1 - distanceToFly / maxExtendDistance);
            // Update tongue target to extend slightly towards the fly
            tonguePhysics.target.x = $ef4c3eb9f5926687$var$lerp(tonguePhysics.target.x, tonguePosition.x + (flyPosition.x - tonguePosition.x) * tongueExtendFactor, lerpAmount);
            tonguePhysics.target.y = $ef4c3eb9f5926687$var$lerp(tonguePhysics.target.y, tonguePosition.y + (flyPosition.y - tonguePosition.y) * tongueExtendFactor, lerpAmount);
        } else {
            tonguePhysics.retracting = true;
            tonguePhysics.target.x = mouthCenterX;
            tonguePhysics.target.y = mouthCenterY + tongueRadius;
        }
    // Start retracting after reaching the cursor's position
    }
    // Apply spring physics in all cases
    const stiffness = 0.1;
    const damping = 0.7;
    tonguePhysics.acceleration.x = (tonguePhysics.target.x - tonguePhysics.position.x) * stiffness;
    tonguePhysics.acceleration.y = (tonguePhysics.target.y - tonguePhysics.position.y) * stiffness;
    tonguePhysics.velocity.x += tonguePhysics.acceleration.x;
    tonguePhysics.velocity.y += tonguePhysics.acceleration.y;
    tonguePhysics.velocity.x *= damping;
    tonguePhysics.velocity.y *= damping;
    tonguePhysics.position.x += tonguePhysics.velocity.x;
    tonguePhysics.position.y += tonguePhysics.velocity.y;
    // Calculate the direction and perpendicular vectors for the sine wave
    const dx = tonguePhysics.position.x - mouthCenterX;
    const dy = tonguePhysics.position.y - mouthCenterY;
    const length = Math.sqrt(dx * dx + dy * dy);
    const dirX = dx / length;
    const dirY = dy / length;
    const perpX = -dirY;
    const perpY = dirX;
    // Parameters for the sine wave
    const frequency = 2; // Number of waves along the tongue's length
    const amplitude = 10; // Amplitude of the sine wave
    // Draw each segment of the tongue
    for(let i = 0; i <= length; i += 10){
        const segmentRatio = i / length;
        const waveOffset = Math.sin(segmentRatio * frequency * Math.PI * 2) * amplitude;
        const segmentX = mouthCenterX + dirX * i + perpX * waveOffset;
        const segmentY = mouthCenterY + dirY * i + perpY * waveOffset;
        if (i === 0) {
            ctx.beginPath();
            ctx.moveTo(segmentX, segmentY);
        } else ctx.lineTo(segmentX, segmentY);
    }
    // Finish the tongue path
    ctx.lineTo(tonguePhysics.position.x, tonguePhysics.position.y);
    ctx.lineWidth = canvas.width / 20; // Set the tongue thickness
    ctx.strokeStyle = "pink";
    ctx.stroke();
    // Interpolating the pad size
    const maxPadWidth = canvas.width / 8;
    const minPadWidth = canvas.width / 25;
    const maxPadHeight = canvas.width / 20;
    const minPadHeight = canvas.width / 30;
    const maxDistance = canvas.width / 2;
    const padWidth = minPadWidth + (maxPadWidth - minPadWidth) * (1 - Math.min(length / maxDistance, 1));
    const padHeight = minPadHeight + (maxPadHeight - minPadHeight) * (1 - Math.min(length / maxDistance, 1));
    // Draw the tongue pad at the end of the tongue
    ctx.beginPath();
    ctx.ellipse(tonguePhysics.position.x, tonguePhysics.position.y, padWidth, padHeight, 0, 0, Math.PI * 2, false);
    ctx.fillStyle = "pink";
    ctx.fill();
}
function $ef4c3eb9f5926687$var$calculateCirclePosition(centerX, centerY, spaceRadius, cursorX, cursorY, circleRadius) {
    const dx = cursorX - centerX;
    const dy = cursorY - centerY;
    const distance = Math.sqrt(dx * dx + dy * dy);
    const maxOffset = spaceRadius - circleRadius;
    if (distance < maxOffset) return {
        x: cursorX,
        y: cursorY
    };
    else {
        const angle = Math.atan2(dy, dx);
        return {
            x: centerX + maxOffset * Math.cos(angle),
            y: centerY + maxOffset * Math.sin(angle)
        };
    }
}
function $ef4c3eb9f5926687$export$a77842e7bbb40de6({ canvas: canvas, baseAmplitude: baseAmplitude, fly: fly, frequency: frequency }) {
    // Randomly change direction more frequently for jittery movement
    if (Math.random() < 0.1) {
        // Around a 10% chance each frame
        fly.direction.x = (Math.random() - 0.5) * 2; // Random direction between -1 and 1
        fly.direction.y = (Math.random() - 0.5) * 2; // Random direction between -1 and 1
    }
    // Randomly apply a sudden turn
    if (Math.random() < 0.02) {
        // Around a 2% chance each frame
        fly.direction.x *= 3; // Double the direction change for a sudden turn
        fly.direction.y *= 2; // Double the direction change for a sudden turn
    }
    // Vary the amplitude randomly for each movement
    const amplitude = baseAmplitude * (0.5 + Math.random());
    // Update position with jittery movement
    fly.position.x += fly.direction.x * amplitude;
    fly.position.y += fly.direction.y * amplitude;
    const jitterIntensity = 10.5;
    fly.position.x += (Math.random() - 0.5) * jitterIntensity;
    fly.position.y += (Math.random() - 0.5) * jitterIntensity;
    const maxY = canvas.height * (2 / 3); // Set the maximum Y to two-thirds of the canvas height
    fly.position.x = Math.max(0, Math.min(fly.position.x, canvas.width));
    fly.position.y = Math.max(0, Math.min(fly.position.y, maxY));
}
function $ef4c3eb9f5926687$export$e978e1a608d3918b(ctx, { canvas: canvas, fly: fly }) {
    ctx.beginPath();
    ctx.arc(fly.position.x, fly.position.y, canvas.width / 160, 0, Math.PI * 2);
    ctx.fillStyle = "black";
    ctx.fill();
}
function $ef4c3eb9f5926687$export$e2c9c09c1857e8ba(ctx, { canvas: canvas, waterLevel: waterLevel }) {
    const waveHeight = canvas.height / 10; // Height of the wave area
    const startY = canvas.height - waveHeight - waterLevel;
    const waveAmplitude = 10; // Height of the wave peaks
    const waveFrequency = 0.01; // Frequency of the waves
    const waveSpeed = 0.002; // Speed of wave movement
    const time = Date.now() * waveSpeed;
    ctx.fillStyle = "rgba(0, 123, 255, 0.3)"; // Transparent blue color
    ctx.beginPath();
    ctx.moveTo(0, startY);
    // Draw the sine wave
    for(let x = 0; x <= canvas.width; x++){
        const y = startY + Math.sin(x * waveFrequency + time) * waveAmplitude;
        ctx.lineTo(x, y);
    }
    // Close the path to fill the area
    ctx.lineTo(canvas.width, canvas.height);
    ctx.lineTo(0, canvas.height);
    ctx.closePath();
    ctx.fill();
}
function $ef4c3eb9f5926687$export$40b3338facbd1d88(ctx, { canvas: canvas }) {
    // Draw the text
    const buttonText = "Click and hold anywhere to play again";
    const fontSize = canvas.width / 20; // Adjust the font size as needed
    ctx.font = `${fontSize}px 'Lilita One'`;
    ctx.fillStyle = "white";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle"; // Align text vertically in the middle
    // Calculate the center of the button for the text
    const textX = canvas.width / 2;
    const textY = canvas.height / 2 + fontSize;
    ctx.fillText(buttonText, textX, textY);
}


function $aa1db0b089ef7146$var$displayLabelAndValue(ctx, { canvas: canvas, label: label, value: value, posX: posX, posY: posY }) {
    const fontSize = canvas.width / 20;
    ctx.font = `${fontSize}px 'Lilita One'`;
    ctx.fillStyle = "white";
    ctx.textAlign = "center";
    ctx.fillText(label, posX, posY);
    ctx.font = `${canvas.width / 10}px 'Lilita One'`;
    ctx.fillText(value, posX, posY + fontSize * 1.75);
}
function $aa1db0b089ef7146$export$f5913d30e8a84df(ctx, { canvas: canvas, remainingTime: remainingTime }) {
    const timeLabelPosX = canvas.width / 2;
    const timeLabelPosY = canvas.height / 8;
    $aa1db0b089ef7146$var$displayLabelAndValue(ctx, {
        canvas: canvas,
        label: "TIME",
        value: `${remainingTime}`,
        posX: timeLabelPosX - canvas.width / 10,
        posY: timeLabelPosY
    });
}
function $aa1db0b089ef7146$export$c6759ff78eadbfc9(ctx, { canvas: canvas, count: count }) {
    const fliesLabelPosX = canvas.width / 2; // Center of the canvas width
    const fliesLabelPosY = canvas.height / 8; // Position for the FLIES label
    $aa1db0b089ef7146$var$displayLabelAndValue(ctx, {
        canvas: canvas,
        label: "FLIES",
        value: `${count}`,
        posX: fliesLabelPosX + canvas.width / 10,
        posY: fliesLabelPosY
    });
}



function $df5bef30413a053b$export$b788c6d84272d404(pointA, pointB) {
    const dx = pointA.x - pointB.x;
    const dy = pointA.y - pointB.y;
    return Math.sqrt(dx * dx + dy * dy);
}
function $df5bef30413a053b$var$hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1] ?? "0", 16),
        g: parseInt(result[2] ?? "0", 16),
        b: parseInt(result[3] ?? "0", 16)
    } : {
        r: 0,
        g: 0,
        b: 0
    };
}
function $df5bef30413a053b$var$rgbToHex(r, g, b) {
    return "#" + [
        r,
        g,
        b
    ].map((x)=>{
        const hex = x.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    }).join("");
}
function $df5bef30413a053b$export$5931e35698b46017(color1, color2, ratio) {
    const rgb1 = $df5bef30413a053b$var$hexToRgb(color1);
    const rgb2 = $df5bef30413a053b$var$hexToRgb(color2);
    const r = Math.round(rgb1.r + ratio * (rgb2.r - rgb1.r));
    const g = Math.round(rgb1.g + ratio * (rgb2.g - rgb1.g));
    const b = Math.round(rgb1.b + ratio * (rgb2.b - rgb1.b));
    return $df5bef30413a053b$var$rgbToHex(r, g, b);
}
function $df5bef30413a053b$export$a3573e86f7ec0911({ canvas: canvas, elapsedSeconds: elapsedSeconds }) {
    for(let i = 0; i < (0, $3bfc08fbd98fce76$export$6435dfeef9d116d2).length - 1; i++){
        const currentColorTime = (0, $3bfc08fbd98fce76$export$6435dfeef9d116d2)[i]?.time ?? 0;
        const nextColorTime = (0, $3bfc08fbd98fce76$export$6435dfeef9d116d2)[i + 1]?.time ?? 0;
        if (elapsedSeconds >= currentColorTime && elapsedSeconds < nextColorTime) {
            const ratio = (elapsedSeconds - currentColorTime) / (nextColorTime - currentColorTime);
            const currentColor = (0, $3bfc08fbd98fce76$export$6435dfeef9d116d2)[i]?.color ?? "#FFFFFF";
            const nextColor = (0, $3bfc08fbd98fce76$export$6435dfeef9d116d2)[i + 1]?.color ?? "#FFFFFF";
            const interpolatedColor = $df5bef30413a053b$export$5931e35698b46017(currentColor, nextColor, ratio);
            canvas.style.backgroundColor = interpolatedColor;
            break;
        }
    }
}
function $df5bef30413a053b$export$61fc7d43ac8f84b0(func, timeout = 300) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(this, args);
        }, timeout);
    };
}


let $b4e14b6b8da86996$var$remainingTime = 60;
let $b4e14b6b8da86996$var$startTime = null;
let $b4e14b6b8da86996$var$isTimerStarted = false;
const $b4e14b6b8da86996$var$countdownDuration = 60;
let $b4e14b6b8da86996$var$fliesCaughtCount = 0;
let $b4e14b6b8da86996$var$holdTimer = null;
const $b4e14b6b8da86996$var$holdDuration = 750;
let $b4e14b6b8da86996$var$waterLevel = 0;
let $b4e14b6b8da86996$var$waterRiseSpeed;
const $b4e14b6b8da86996$var$waterFallSpeed = 10;
let $b4e14b6b8da86996$var$isGameOver = false;
let $b4e14b6b8da86996$var$timesUpFontSize = 0;
let $b4e14b6b8da86996$var$showRetryButton = false;
let $b4e14b6b8da86996$var$canvas;
let $b4e14b6b8da86996$var$ctx;
let $b4e14b6b8da86996$var$animationFrameId;
let $b4e14b6b8da86996$var$eyesY;
let $b4e14b6b8da86996$var$frogRotation = 0;
let $b4e14b6b8da86996$var$frogCenterX;
let $b4e14b6b8da86996$var$frogCenterY;
let $b4e14b6b8da86996$var$frogRadiusX;
let $b4e14b6b8da86996$var$frogRadiusY;
let $b4e14b6b8da86996$var$frogCurrentY;
let $b4e14b6b8da86996$var$frogTargetY;
let $b4e14b6b8da86996$var$cursorX = 0;
let $b4e14b6b8da86996$var$cursorY = 0;
let $b4e14b6b8da86996$var$cursorRadius;
let $b4e14b6b8da86996$var$targetCursorRadius;
let $b4e14b6b8da86996$var$cursorRotationAngle = 0;
let $b4e14b6b8da86996$var$isMouseDown = false;
let $b4e14b6b8da86996$var$isResetting = false;
let $b4e14b6b8da86996$var$targetTonguePosition = {
    x: 0,
    y: 0
};
let $b4e14b6b8da86996$var$tonguePhysics;
let $b4e14b6b8da86996$var$isTongueMoving = false;
let $b4e14b6b8da86996$var$flies = [];
const $b4e14b6b8da86996$var$numberOfFlies = 15;
function $b4e14b6b8da86996$var$initializeFlies(numberOfFlies) {
    $b4e14b6b8da86996$var$flies = [];
    for(let i = 0; i < numberOfFlies; i++)$b4e14b6b8da86996$var$flies.push({
        position: {
            x: Math.random() * $b4e14b6b8da86996$var$canvas.width,
            y: Math.random() * $b4e14b6b8da86996$var$canvas.height / 2
        },
        direction: {
            x: 1,
            y: 1
        },
        lastDirectionChangeTime: 0,
        isCaught: false
    });
}
function $b4e14b6b8da86996$var$initializeCanvas() {
    $b4e14b6b8da86996$var$canvas = document.getElementById("drawingCanvas");
    if (!$b4e14b6b8da86996$var$canvas) throw new Error("Canvas not found");
    $b4e14b6b8da86996$var$canvas.width = window.innerWidth;
    $b4e14b6b8da86996$var$canvas.height = window.innerHeight;
    $b4e14b6b8da86996$var$ctx = (0, $4c0f0ee047d80e21$export$c6141e7c4932b646)($b4e14b6b8da86996$var$canvas);
    $b4e14b6b8da86996$var$cursorRadius = $b4e14b6b8da86996$var$canvas.width / 20;
    $b4e14b6b8da86996$var$targetCursorRadius = $b4e14b6b8da86996$var$cursorRadius;
    $b4e14b6b8da86996$var$eyesY = $b4e14b6b8da86996$var$canvas.height - $b4e14b6b8da86996$var$canvas.height / 20;
    $b4e14b6b8da86996$var$frogCenterX = $b4e14b6b8da86996$var$canvas.width / 2;
    $b4e14b6b8da86996$var$frogCenterY = $b4e14b6b8da86996$var$canvas.height;
    $b4e14b6b8da86996$var$frogRadiusX = $b4e14b6b8da86996$var$canvas.width / 2;
    $b4e14b6b8da86996$var$frogRadiusY = $b4e14b6b8da86996$var$canvas.height / 4;
    $b4e14b6b8da86996$var$frogCurrentY = $b4e14b6b8da86996$var$frogCenterY;
    $b4e14b6b8da86996$var$frogTargetY = $b4e14b6b8da86996$var$frogCenterY;
    $b4e14b6b8da86996$var$tonguePhysics = {
        position: {
            x: 0,
            y: 0
        },
        target: {
            x: 0,
            y: 0
        },
        velocity: {
            x: 0,
            y: 0
        },
        acceleration: {
            x: 0,
            y: 0
        },
        damping: 0.85,
        retracting: false,
        stiffness: 0.2
    };
    $b4e14b6b8da86996$var$initializeFlies($b4e14b6b8da86996$var$numberOfFlies);
    $b4e14b6b8da86996$var$waterRiseSpeed = $b4e14b6b8da86996$var$canvas.height / 100;
    const initialColor = (0, $3bfc08fbd98fce76$export$6435dfeef9d116d2)[0]?.color ?? "#FFFFFF";
    $b4e14b6b8da86996$var$canvas.style.backgroundColor = initialColor;
    $b4e14b6b8da86996$var$canvas.style.cursor = "none";
}
const $b4e14b6b8da86996$var$loadGoogleFont = ()=>{
    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=Lilita+One&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
};
function $b4e14b6b8da86996$var$getTouchPos(canvas, touchEvent) {
    const rect = canvas.getBoundingClientRect();
    const touch = touchEvent.touches[0];
    if (!touch) return {
        x: 0,
        y: 0
    };
    return {
        x: touch.clientX - rect.left,
        y: touch.clientY - rect.top
    };
}
function $b4e14b6b8da86996$var$handleClick(clientX, clientY) {
    if (!$b4e14b6b8da86996$var$isTimerStarted) {
        $b4e14b6b8da86996$var$startTime = Date.now();
        $b4e14b6b8da86996$var$isTimerStarted = true;
    }
    if ($b4e14b6b8da86996$var$isTongueMoving) return;
    if ($b4e14b6b8da86996$var$isGameOver) {
        $b4e14b6b8da86996$var$isResetting = true;
        $b4e14b6b8da86996$var$holdTimer = setTimeout(()=>{
            window.location.reload();
        }, $b4e14b6b8da86996$var$holdDuration);
        return;
    }
    $b4e14b6b8da86996$var$isMouseDown = true;
    const rect = $b4e14b6b8da86996$var$canvas.getBoundingClientRect();
    $b4e14b6b8da86996$var$targetTonguePosition.x = clientX - rect.left;
    $b4e14b6b8da86996$var$targetTonguePosition.y = clientY - rect.top;
    $b4e14b6b8da86996$var$frogTargetY = $b4e14b6b8da86996$var$frogCenterY + $b4e14b6b8da86996$var$canvas.height / 40;
}
const $b4e14b6b8da86996$var$handleMouseUp = ()=>{
    $b4e14b6b8da86996$var$isMouseDown = false;
    $b4e14b6b8da86996$var$isResetting = false;
    $b4e14b6b8da86996$var$frogTargetY = $b4e14b6b8da86996$var$frogCenterY;
    if ($b4e14b6b8da86996$var$isGameOver) {
        if ($b4e14b6b8da86996$var$holdTimer) {
            clearTimeout($b4e14b6b8da86996$var$holdTimer);
            $b4e14b6b8da86996$var$holdTimer = null;
        }
    }
};
function $b4e14b6b8da86996$var$handleTouchStart(e) {
    e.preventDefault(); // Prevent scrolling when touching the canvas
    const touchPos = $b4e14b6b8da86996$var$getTouchPos($b4e14b6b8da86996$var$canvas, e);
    $b4e14b6b8da86996$var$handleClick(touchPos.x, touchPos.y);
}
// Define the touch end handler
function $b4e14b6b8da86996$var$handleTouchEnd() {
    $b4e14b6b8da86996$var$handleMouseUp();
}
document.addEventListener("DOMContentLoaded", async ()=>{
    $b4e14b6b8da86996$var$loadGoogleFont();
    $b4e14b6b8da86996$var$initializeCanvas();
    await $b4e14b6b8da86996$var$animate();
    $b4e14b6b8da86996$var$canvas.addEventListener("mousemove", (e)=>{
        const rect = $b4e14b6b8da86996$var$canvas.getBoundingClientRect();
        $b4e14b6b8da86996$var$cursorX = e.clientX - rect.left;
        $b4e14b6b8da86996$var$cursorY = e.clientY - rect.top;
    });
    $b4e14b6b8da86996$var$canvas.addEventListener("mousedown", (e)=>{
        $b4e14b6b8da86996$var$handleClick(e.clientX, e.clientY);
    });
    $b4e14b6b8da86996$var$canvas.addEventListener("mouseup", $b4e14b6b8da86996$var$handleMouseUp);
    $b4e14b6b8da86996$var$canvas.addEventListener("touchmove", (e)=>{
        e.preventDefault(); // Prevent scrolling when touching the canvas
        const touchPos = $b4e14b6b8da86996$var$getTouchPos($b4e14b6b8da86996$var$canvas, e);
        $b4e14b6b8da86996$var$cursorX = touchPos.x;
        $b4e14b6b8da86996$var$cursorY = touchPos.y;
    }, {
        passive: false
    });
    $b4e14b6b8da86996$var$canvas.addEventListener("touchstart", $b4e14b6b8da86996$var$handleTouchStart, {
        passive: false
    });
    $b4e14b6b8da86996$var$canvas.addEventListener("touchend", $b4e14b6b8da86996$var$handleTouchEnd, {
        passive: false
    });
    window.addEventListener("resize", (0, $df5bef30413a053b$export$61fc7d43ac8f84b0)($b4e14b6b8da86996$var$handleResize));
});
async function $b4e14b6b8da86996$var$handleResize() {
    if ($b4e14b6b8da86996$var$animationFrameId) cancelAnimationFrame($b4e14b6b8da86996$var$animationFrameId);
    $b4e14b6b8da86996$var$initializeCanvas();
    await $b4e14b6b8da86996$var$animate();
}
function $b4e14b6b8da86996$var$animateFrog() {
    const angleToCursor = Math.atan2($b4e14b6b8da86996$var$cursorY - $b4e14b6b8da86996$var$frogCenterY, $b4e14b6b8da86996$var$cursorX - $b4e14b6b8da86996$var$frogCenterX);
    // Convert the desired max rotation to radians
    const maxRotation = 1 * (Math.PI / 180); // Approximately 10 degrees in either direction
    // Adjust the angleToCursor to the frog's perspective
    let desiredRotation = angleToCursor - Math.PI / 2;
    // Normalize the rotation to be within the range of -PI to PI
    if (desiredRotation < -Math.PI) desiredRotation += 2 * Math.PI;
    if (desiredRotation > Math.PI) desiredRotation -= 2 * Math.PI;
    // Since it's backwards, invert the sign of the desired rotation
    desiredRotation = -desiredRotation; // Invert the direction of rotation
    // Clamp the rotation within the maxRotation bounds
    desiredRotation = Math.max(-maxRotation, Math.min(desiredRotation, maxRotation));
    // Apply a lerp (linear interpolation) to smooth out the rotation
    const rotationSpeed = 0.025; // This controls how quickly the frog rotates towards the cursor
    $b4e14b6b8da86996$var$frogRotation += (desiredRotation - $b4e14b6b8da86996$var$frogRotation) * rotationSpeed;
    // Apply the rotation before drawing the frog and its components
    $b4e14b6b8da86996$var$ctx.save(); // Save the current state of the canvas
    $b4e14b6b8da86996$var$ctx.translate($b4e14b6b8da86996$var$frogCenterX, $b4e14b6b8da86996$var$frogCenterY); // Move to the frog's center
    $b4e14b6b8da86996$var$ctx.rotate($b4e14b6b8da86996$var$frogRotation); // Apply the rotation
    $b4e14b6b8da86996$var$ctx.translate(-$b4e14b6b8da86996$var$frogCenterX, -$b4e14b6b8da86996$var$frogCenterY); // Move back
    let closestFlyDistance = Number.MAX_VALUE;
    let closestFly = {};
    const interpolationFactor = 0.05;
    $b4e14b6b8da86996$var$frogCurrentY += ($b4e14b6b8da86996$var$frogTargetY - $b4e14b6b8da86996$var$frogCurrentY) * interpolationFactor;
    // Find the closest fly to the cursor
    $b4e14b6b8da86996$var$flies.forEach((fly)=>{
        const distance = (0, $df5bef30413a053b$export$b788c6d84272d404)(fly.position, {
            x: $b4e14b6b8da86996$var$cursorX,
            y: $b4e14b6b8da86996$var$cursorY
        });
        if (distance < closestFlyDistance) {
            closestFlyDistance = distance;
            closestFly = fly;
        }
    });
    if (!closestFly) throw new Error("No fly found");
    // If there is at least one fly, calculate the jaw offset based on the closest one
    let jawOffset = 0;
    jawOffset = (0, $ef4c3eb9f5926687$export$1a7019e83c643e8b)({
        cursorY: $b4e14b6b8da86996$var$cursorY,
        centerY: $b4e14b6b8da86996$var$canvas.height,
        flyDistance: closestFlyDistance,
        maxDistance: $b4e14b6b8da86996$var$canvas.height,
        minDistance: $b4e14b6b8da86996$var$canvas.height / 10,
        threshold: $b4e14b6b8da86996$var$canvas.height / 2
    });
    (0, $ef4c3eb9f5926687$export$cacb359be49a4863)($b4e14b6b8da86996$var$ctx, {
        canvas: $b4e14b6b8da86996$var$canvas,
        jawOffset: jawOffset,
        centerY: $b4e14b6b8da86996$var$frogCurrentY
    });
    if ($b4e14b6b8da86996$var$isMouseDown) $b4e14b6b8da86996$var$isTongueMoving = true;
    else if (Math.abs($b4e14b6b8da86996$var$tonguePhysics.position.y - $b4e14b6b8da86996$var$canvas.width / 2) < $b4e14b6b8da86996$var$canvas.height / 2.5) $b4e14b6b8da86996$var$isTongueMoving = false;
    (0, $ef4c3eb9f5926687$export$f3bec86bc9a1c71a)($b4e14b6b8da86996$var$ctx, {
        canvas: $b4e14b6b8da86996$var$canvas,
        cursorX: $b4e14b6b8da86996$var$cursorX,
        cursorY: $b4e14b6b8da86996$var$cursorY,
        eyesY: $b4e14b6b8da86996$var$eyesY,
        flyPosition: closestFly.position,
        isMouseDown: $b4e14b6b8da86996$var$isMouseDown,
        targetTonguePosition: $b4e14b6b8da86996$var$targetTonguePosition,
        tonguePhysics: $b4e14b6b8da86996$var$tonguePhysics
    });
    (0, $ef4c3eb9f5926687$export$c4be8a24729de865)($b4e14b6b8da86996$var$ctx, {
        centerX: $b4e14b6b8da86996$var$frogCenterX,
        centerY: $b4e14b6b8da86996$var$frogCurrentY,
        radiusX: $b4e14b6b8da86996$var$frogRadiusX,
        radiusY: $b4e14b6b8da86996$var$frogRadiusY
    });
    (0, $ef4c3eb9f5926687$export$5987d8c342abca63)($b4e14b6b8da86996$var$ctx, {
        height: $b4e14b6b8da86996$var$canvas.width / 100,
        width: $b4e14b6b8da86996$var$canvas.width / 200,
        x: $b4e14b6b8da86996$var$canvas.width / 2,
        xOffset: $b4e14b6b8da86996$var$canvas.width / 20,
        yOffset: $b4e14b6b8da86996$var$frogCurrentY - $b4e14b6b8da86996$var$canvas.height / 5
    });
    (0, $ef4c3eb9f5926687$export$b02dbbf73e520614)($b4e14b6b8da86996$var$ctx, {
        x: $b4e14b6b8da86996$var$canvas.width / 2,
        width: $b4e14b6b8da86996$var$canvas.width / 50,
        height: $b4e14b6b8da86996$var$canvas.width / 50,
        xOffset: $b4e14b6b8da86996$var$canvas.width / 4,
        yOffset: $b4e14b6b8da86996$var$frogCurrentY - $b4e14b6b8da86996$var$canvas.height / 20
    });
    (0, $ef4c3eb9f5926687$export$ae8c489e78e84ecd)($b4e14b6b8da86996$var$ctx, {
        canvas: $b4e14b6b8da86996$var$canvas,
        cursorX: $b4e14b6b8da86996$var$cursorX,
        cursorY: $b4e14b6b8da86996$var$cursorY,
        eyesY: $b4e14b6b8da86996$var$frogCurrentY - $b4e14b6b8da86996$var$canvas.height / 20
    });
    // left arm
    (0, $ef4c3eb9f5926687$export$746a4a768e6973c8)($b4e14b6b8da86996$var$ctx, {
        centerY: $b4e14b6b8da86996$var$frogCurrentY,
        circleRadius: $b4e14b6b8da86996$var$canvas.width / 20,
        control: {
            x: $b4e14b6b8da86996$var$canvas.width / 10,
            y: $b4e14b6b8da86996$var$frogCurrentY
        },
        cursorX: $b4e14b6b8da86996$var$cursorX,
        cursorY: $b4e14b6b8da86996$var$cursorY,
        isLeftArm: true,
        start: {
            x: $b4e14b6b8da86996$var$canvas.width / 10,
            y: $b4e14b6b8da86996$var$frogCurrentY
        }
    });
    // right arm
    (0, $ef4c3eb9f5926687$export$746a4a768e6973c8)($b4e14b6b8da86996$var$ctx, {
        centerY: $b4e14b6b8da86996$var$frogCurrentY,
        circleRadius: $b4e14b6b8da86996$var$canvas.width / 20,
        control: {
            x: $b4e14b6b8da86996$var$canvas.width - $b4e14b6b8da86996$var$canvas.width / 10,
            y: $b4e14b6b8da86996$var$frogCurrentY
        },
        cursorX: $b4e14b6b8da86996$var$cursorX,
        cursorY: $b4e14b6b8da86996$var$cursorY,
        isLeftArm: false,
        start: {
            x: $b4e14b6b8da86996$var$canvas.width - $b4e14b6b8da86996$var$canvas.width / 10,
            y: $b4e14b6b8da86996$var$frogCurrentY
        }
    });
    $b4e14b6b8da86996$var$ctx.restore(); // Restore the canvas state to remove the rotation for other elements
}
function $b4e14b6b8da86996$var$animateFlies() {
    $b4e14b6b8da86996$var$flies.forEach((fly)=>{
        const distanceToTongue = (0, $df5bef30413a053b$export$b788c6d84272d404)($b4e14b6b8da86996$var$tonguePhysics.position, fly.position);
        const distanceToCursor = (0, $df5bef30413a053b$export$b788c6d84272d404)({
            x: $b4e14b6b8da86996$var$cursorX,
            y: $b4e14b6b8da86996$var$cursorY
        }, fly.position);
        const cursorCatchThreshold = $b4e14b6b8da86996$var$cursorRadius;
        // Check if the fly is within the catch threshold of both the tongue and the cursor, and if it's not already caught
        if (distanceToTongue < cursorCatchThreshold && distanceToCursor < cursorCatchThreshold && $b4e14b6b8da86996$var$isMouseDown && !fly.isCaught) {
            fly.isCaught = true;
            $b4e14b6b8da86996$var$fliesCaughtCount++;
            // Randomly position the fly around the tongue's tip
            const angle = Math.random() * Math.PI * 2; // Random angle for direction
            const radius = $b4e14b6b8da86996$var$fliesCaughtCount * $b4e14b6b8da86996$var$canvas.width / $b4e14b6b8da86996$var$canvas.width / 4; // Distance from the tongue's tip
            fly.tongueOffset = {
                x: Math.cos(angle) * radius,
                y: Math.sin(angle) * radius
            };
        }
        if (fly.isCaught) {
            if (!$b4e14b6b8da86996$var$isMouseDown && $b4e14b6b8da86996$var$tonguePhysics.position.y > $b4e14b6b8da86996$var$frogCenterY - $b4e14b6b8da86996$var$frogRadiusY / 2 - 200) {
                // When the mouse is released and the tongue is retracted, release the fly and reposition it randomly on the canvas
                fly.isCaught = false;
                fly.position.x = Math.random() * $b4e14b6b8da86996$var$canvas.width;
                fly.position.y = Math.random() * $b4e14b6b8da86996$var$canvas.height / 2;
            } else if (fly.tongueOffset) {
                // The fly is caught and should be attached to the tongue's position with the offset
                fly.position.x = $b4e14b6b8da86996$var$tonguePhysics.position.x + fly.tongueOffset.x;
                fly.position.y = $b4e14b6b8da86996$var$tonguePhysics.position.y + fly.tongueOffset.y;
            }
            (0, $ef4c3eb9f5926687$export$e978e1a608d3918b)($b4e14b6b8da86996$var$ctx, {
                canvas: $b4e14b6b8da86996$var$canvas,
                fly: fly
            }); // Draw the fly stuck to the tongue pad
        } else {
            // Handle the moving fly
            (0, $ef4c3eb9f5926687$export$a77842e7bbb40de6)({
                baseAmplitude: 2,
                canvas: $b4e14b6b8da86996$var$canvas,
                fly: fly,
                frequency: 0.001
            });
            (0, $ef4c3eb9f5926687$export$e978e1a608d3918b)($b4e14b6b8da86996$var$ctx, {
                canvas: $b4e14b6b8da86996$var$canvas,
                fly: fly
            }); // Draw the fly normally
        }
    });
}
function $b4e14b6b8da86996$var$animateCursor() {
    let onTarget = false;
    // Check if the cursor is on target with any of the flies
    for (const fly of $b4e14b6b8da86996$var$flies){
        const dx = $b4e14b6b8da86996$var$cursorX - fly.position.x;
        const dy = $b4e14b6b8da86996$var$cursorY - fly.position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (distance < $b4e14b6b8da86996$var$cursorRadius) {
            onTarget = true;
            break; // Stop checking if one fly is already on target
        }
    }
    // Determine the target cursor radius and rotation angle
    $b4e14b6b8da86996$var$targetCursorRadius = onTarget ? $b4e14b6b8da86996$var$canvas.width / 30 : $b4e14b6b8da86996$var$canvas.width / 20;
    $b4e14b6b8da86996$var$cursorRotationAngle = onTarget ? ($b4e14b6b8da86996$var$cursorRotationAngle + 3) % 360 : $b4e14b6b8da86996$var$cursorRotationAngle;
    // Smoothly update the cursor's radius using lerp
    const lerpFactor = 0.3;
    $b4e14b6b8da86996$var$cursorRadius += ($b4e14b6b8da86996$var$targetCursorRadius - $b4e14b6b8da86996$var$cursorRadius) * lerpFactor;
    // Draw the cursor with the updated properties
    (0, $ef4c3eb9f5926687$export$69c8eaa09502cdf7)($b4e14b6b8da86996$var$ctx, {
        cursorX: $b4e14b6b8da86996$var$cursorX,
        cursorY: $b4e14b6b8da86996$var$cursorY,
        cursorRadius: $b4e14b6b8da86996$var$cursorRadius,
        onTarget: onTarget,
        rotationDegrees: $b4e14b6b8da86996$var$cursorRotationAngle,
        thickness: $b4e14b6b8da86996$var$canvas.height / 40
    });
}
function $b4e14b6b8da86996$var$animateTimesUpMessage() {
    if ($b4e14b6b8da86996$var$timesUpFontSize < $b4e14b6b8da86996$var$canvas.width / 10) $b4e14b6b8da86996$var$timesUpFontSize += 5; // Increment font size by 5 each frame
    else $b4e14b6b8da86996$var$showRetryButton = true; // Show retry button once animation is complete
    $b4e14b6b8da86996$var$ctx.font = `${$b4e14b6b8da86996$var$timesUpFontSize}px 'Lilita One'`;
    $b4e14b6b8da86996$var$ctx.fillStyle = "white";
    $b4e14b6b8da86996$var$ctx.textAlign = "center";
    $b4e14b6b8da86996$var$ctx.fillText("TIME'S UP!", $b4e14b6b8da86996$var$canvas.width / 2, $b4e14b6b8da86996$var$canvas.height / 2 - $b4e14b6b8da86996$var$canvas.height / 10);
}
function $b4e14b6b8da86996$var$updateCursorVisibility() {
    if ($b4e14b6b8da86996$var$isGameOver) $b4e14b6b8da86996$var$canvas.style.cursor = "default"; // Show the cursor when the game is over
    else $b4e14b6b8da86996$var$canvas.style.cursor = "none"; // Hide the cursor during the game
}
function $b4e14b6b8da86996$var$animateWaterWave() {
    if ($b4e14b6b8da86996$var$isGameOver && $b4e14b6b8da86996$var$isResetting) // Increase water level while holding the mouse
    $b4e14b6b8da86996$var$waterLevel = Math.min($b4e14b6b8da86996$var$waterLevel + $b4e14b6b8da86996$var$waterRiseSpeed, $b4e14b6b8da86996$var$canvas.height);
    else // Decrease water level when the mouse is released
    $b4e14b6b8da86996$var$waterLevel = Math.max($b4e14b6b8da86996$var$waterLevel - $b4e14b6b8da86996$var$waterFallSpeed, 0);
    (0, $ef4c3eb9f5926687$export$e2c9c09c1857e8ba)($b4e14b6b8da86996$var$ctx, {
        canvas: $b4e14b6b8da86996$var$canvas,
        waterLevel: $b4e14b6b8da86996$var$waterLevel
    });
}
async function $b4e14b6b8da86996$var$checkIfHighScore(score) {
    try {
        const response = await fetch("https://time-flies-server.onrender.com/is-high-score", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                score: score
            })
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error("Error checking high score");
    }
}
function $b4e14b6b8da86996$var$createLeaderboardTable(leaderboard) {
    // Create the table element
    const table = document.createElement("table");
    table.style.width = "100%";
    table.style.borderCollapse = "collapse";
    // Create the header row
    const headerRow = document.createElement("tr");
    [
        "Rank",
        "Name",
        "Score"
    ].forEach((headerText)=>{
        const headerCell = document.createElement("th");
        headerCell.textContent = headerText;
        headerCell.style.padding = "8px";
        headerCell.style.borderBottom = "1px solid #ddd";
        headerCell.style.background = "#f3f3f3";
        headerRow.appendChild(headerCell);
    });
    table.appendChild(headerRow);
    // Add the leaderboard entries to the table
    leaderboard.forEach((entry, index)=>{
        const row = document.createElement("tr");
        row.style.backgroundColor = index % 2 ? "#f9f9f9" : "#fff"; // Alternate row colors
        // Rank
        const rankCell = document.createElement("td");
        rankCell.textContent = (index + 1).toString();
        rankCell.style.textAlign = "center";
        rankCell.style.padding = "8px";
        row.appendChild(rankCell);
        // Name
        const nameCell = document.createElement("td");
        nameCell.textContent = entry.name;
        nameCell.style.textTransform = "uppercase";
        nameCell.style.padding = "8px";
        if (entry.name === "YOUR NAME HERE") nameCell.style.fontWeight = "bold";
        row.appendChild(nameCell);
        // Score
        const scoreCell = document.createElement("td");
        scoreCell.textContent = entry.score.toString();
        scoreCell.style.textAlign = "center";
        scoreCell.style.padding = "8px";
        row.appendChild(scoreCell);
        table.appendChild(row);
    });
    return table;
}
function $b4e14b6b8da86996$var$createHighScoreModal({ leaderboard: leaderboard, playerScore: playerScore }) {
    const yourNameHere = "YOUR NAME HERE";
    let insertIndex = leaderboard.findIndex((entry)=>playerScore > entry.score);
    if (insertIndex === -1) {
        if (leaderboard.length < 10) // If the leaderboard is not full, add the score to the end
        leaderboard.push({
            name: yourNameHere,
            score: playerScore
        });
        else if (playerScore > (leaderboard[leaderboard.length - 1]?.score ?? 0)) {
            // If the leaderboard is full but the player's score is higher than the last score
            leaderboard.pop(); // Remove the last score
            leaderboard.push({
                name: yourNameHere,
                score: playerScore
            }); // Add the new score to the end
        }
    } else {
        // If the player's score is higher than any of the existing scores
        leaderboard.splice(insertIndex, 0, {
            name: yourNameHere,
            score: playerScore
        });
        // Ensure the leaderboard does not exceed 10 entries
        if (leaderboard.length > 10) leaderboard.pop();
    }
    // After insertion, sort the leaderboard from highest to lowest
    leaderboard.sort((a, b)=>b.score - a.score);
    const modal = document.createElement("div");
    modal.className = "highScoreModal";
    modal.style.cssText = "position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); display: flex; align-items: center; justify-content: center;";
    const modalContent = document.createElement("div");
    modalContent.className = "modal-content";
    modalContent.style.cssText = "background-color: white; padding: 20px; border-radius: 5px; text-align: center; position: relative;";
    // Close button
    const closeButton = document.createElement("button");
    closeButton.textContent = "X";
    closeButton.style.cssText = "font-family: 'Lilita One'; position: absolute; top: 10px; right: 10px; border: none; background: none; cursor: pointer; font-size: 24px;";
    closeButton.onclick = function() {
        document.body.removeChild(modal);
    };
    modalContent.appendChild(closeButton);
    modal.onclick = function(event) {
        if (event.target === modal) document.body.removeChild(modal);
    };
    modalContent.onclick = function(event) {
        event.stopPropagation();
    };
    const title = document.createElement("h1");
    title.textContent = "NEW HIGH SCORE!";
    modalContent.appendChild(title);
    const scoreDisplay = document.createElement("h2");
    scoreDisplay.textContent = `YOU ATE ${$b4e14b6b8da86996$var$fliesCaughtCount} ${$b4e14b6b8da86996$var$fliesCaughtCount === 1 ? "FLY" : "FLIES"}`;
    modalContent.appendChild(scoreDisplay);
    const form = document.createElement("form");
    form.id = "highScoreForm";
    form.addEventListener("submit", $b4e14b6b8da86996$var$submitHighScore);
    const input = document.createElement("input");
    input.type = "text";
    input.id = "playerName";
    input.name = "playerName";
    input.placeholder = "Enter your name";
    input.required = true;
    input.style.cssText = "margin-bottom: 10px;";
    const submitButton = document.createElement("button");
    submitButton.type = "submit";
    submitButton.id = "submit";
    submitButton.textContent = "SUBMIT";
    submitButton.style.cssText = "cursor: pointer;";
    form.appendChild(input);
    const errorParagraph = document.createElement("p");
    errorParagraph.id = "error-message";
    errorParagraph.style.display = "none";
    errorParagraph.style.color = "red";
    modalContent.appendChild(errorParagraph);
    form.appendChild(submitButton);
    const table = $b4e14b6b8da86996$var$createLeaderboardTable(leaderboard);
    modalContent.appendChild(table);
    modalContent.appendChild(form);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);
}
async function $b4e14b6b8da86996$var$checkAndShowHighScoreModal(fliesCaughtCount) {
    try {
        const { isHighScore: isHighScore, leaderboard: leaderboard } = await $b4e14b6b8da86996$var$checkIfHighScore(fliesCaughtCount);
        if (isHighScore) {
            $b4e14b6b8da86996$var$createHighScoreModal({
                leaderboard: leaderboard,
                playerScore: fliesCaughtCount
            });
            const modal = document.getElementById("modal");
            if (modal) // Check if the modal exists
            modal.style.display = "block";
        }
    } catch (error) {
        console.error("Error checking high score:", error);
    }
}
async function $b4e14b6b8da86996$var$submitHighScore(event) {
    event.preventDefault();
    // Use a type guard to check if the element is an HTMLInputElement
    const playerNameInput = document.getElementById("playerName");
    if (playerNameInput && playerNameInput instanceof HTMLInputElement) {
        const playerName = playerNameInput.value;
        const filter = new (0, (/*@__PURE__*/$parcel$interopDefault($d397f6c459ccf808$exports)))();
        if (filter.isProfane(playerName)) {
            const errorMessage = document.getElementById("error-message");
            if (errorMessage) {
                errorMessage.textContent = "Please enter an appropriate name";
                errorMessage.style.display = "block";
            }
            return;
        } else {
            const errorMessage = document.getElementById("error-message");
            if (errorMessage) errorMessage.style.display = "none";
        }
        try {
            const response = await fetch("https://time-flies-server.onrender.com/update-leaderboard", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    name: playerName.split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" "),
                    score: $b4e14b6b8da86996$var$fliesCaughtCount
                })
            });
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        } catch (error) {
            console.error("Error submitting score:", error);
        }
        const modal = document.getElementsByClassName("highScoreModal")[0];
        if (modal) modal.remove();
    } else console.error("Player name input element not found or invalid type");
}
async function $b4e14b6b8da86996$var$animate() {
    $b4e14b6b8da86996$var$ctx.clearRect(0, 0, $b4e14b6b8da86996$var$ctx.canvas.width, $b4e14b6b8da86996$var$ctx.canvas.height);
    (0, $aa1db0b089ef7146$export$f5913d30e8a84df)($b4e14b6b8da86996$var$ctx, {
        canvas: $b4e14b6b8da86996$var$canvas,
        remainingTime: $b4e14b6b8da86996$var$remainingTime
    });
    (0, $aa1db0b089ef7146$export$c6759ff78eadbfc9)($b4e14b6b8da86996$var$ctx, {
        canvas: $b4e14b6b8da86996$var$canvas,
        count: $b4e14b6b8da86996$var$fliesCaughtCount
    });
    if ($b4e14b6b8da86996$var$isTimerStarted && $b4e14b6b8da86996$var$startTime != null) {
        const currentTime = Date.now();
        const elapsedSeconds = Math.floor((currentTime - $b4e14b6b8da86996$var$startTime) / 1000);
        $b4e14b6b8da86996$var$remainingTime = Math.max(0, $b4e14b6b8da86996$var$countdownDuration - elapsedSeconds); // Ensure time doesn't go below 0
        (0, $df5bef30413a053b$export$a3573e86f7ec0911)({
            canvas: $b4e14b6b8da86996$var$canvas,
            elapsedSeconds: elapsedSeconds
        });
    }
    if ($b4e14b6b8da86996$var$remainingTime <= 0 && !$b4e14b6b8da86996$var$isGameOver) {
        $b4e14b6b8da86996$var$isGameOver = true;
        $b4e14b6b8da86996$var$updateCursorVisibility();
        try {
            $b4e14b6b8da86996$var$checkAndShowHighScoreModal($b4e14b6b8da86996$var$fliesCaughtCount);
        } catch (error) {
            console.log(error);
        }
    }
    if (!$b4e14b6b8da86996$var$isGameOver) $b4e14b6b8da86996$var$animateCursor();
    $b4e14b6b8da86996$var$animateFrog();
    $b4e14b6b8da86996$var$animateFlies();
    $b4e14b6b8da86996$var$animateWaterWave();
    if ($b4e14b6b8da86996$var$isGameOver) $b4e14b6b8da86996$var$animateTimesUpMessage();
    if ($b4e14b6b8da86996$var$showRetryButton) (0, $ef4c3eb9f5926687$export$40b3338facbd1d88)($b4e14b6b8da86996$var$ctx, {
        canvas: $b4e14b6b8da86996$var$canvas
    });
    $b4e14b6b8da86996$var$animationFrameId = requestAnimationFrame($b4e14b6b8da86996$var$animate);
}


//# sourceMappingURL=index.71b7141a.js.map
